"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBroadcastChannel = void 0;
class FakeChannel {
    constructor(_name) { }
    postMessage(_message) { }
}
const channel = typeof BroadcastChannel !== 'undefined'
    ? new BroadcastChannel('oneauth-sdk')
    : new FakeChannel('oneauth-sdk');
function getBroadcastChannel() {
    return channel;
}
exports.getBroadcastChannel = getBroadcastChannel;
